import React from 'react';

const SvgBr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BR_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <circle id="BR_svg__c" cx={4.667} cy={4.667} r={4.667} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BR_svg__b" fill="#fff">
        <use xlinkHref="#BR_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BR_svg__a" />
      <path fill="#05AB41" mask="url(#BR_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M3.229 10.364c-.31-.201-.304-.53 0-.728L13.438 3.03c.31-.2.82-.196 1.124 0l10.21 6.606c.31.201.303.53 0 .728l-10.21 6.606c-.31.2-.82.196-1.124 0l-10.21-6.606z"
        fill="#FDD216"
        mask="url(#BR_svg__b)"
      />
      <g mask="url(#BR_svg__b)">
        <g transform="translate(9.333 5.333)">
          <mask id="BR_svg__d" fill="#fff">
            <use xlinkHref="#BR_svg__c" />
          </mask>
          <use fill="#053087" xlinkHref="#BR_svg__c" />
          <path
            d="M-.667 4C0 3.333 2.41 3.645 4.667 4 6.923 4.355 9.34 5.341 10 6"
            stroke="#FFF"
            strokeWidth={1.333}
            strokeLinecap="square"
            mask="url(#BR_svg__d)"
            transform="rotate(6 4.667 4.804)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgBr;
